var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArbitrumOgo = function SvgArbitrumOgo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arbitrum-ogo_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".arbitrum-ogo_svg__st1{fill:#213147}.arbitrum-ogo_svg__st2{fill:#12aaff}.arbitrum-ogo_svg__st4{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "arbitrum-ogo_svg__Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arbitrum-ogo_svg___2405588477232"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h2500v2500H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arbitrum-ogo_svg__st1",
    d: "M226 760v980c0 63 33 120 88 152l849 490c54 31 121 31 175 0l849-490c54-31 88-89 88-152V760c0-63-33-120-88-152l-849-490c-54-31-121-31-175 0L314 608c-54 31-87 89-87 152h-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "arbitrum-ogo_svg__st2",
    d: "m1435 1440-121 332c-3 9-3 19 0 29l208 571 241-139-289-793c-7-18-32-18-39 0zM1678 882c-7-18-32-18-39 0l-121 332c-3 9-3 19 0 29l341 935 241-139-422-1156v-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1250 155c6 0 12 2 17 5l918 530c11 6 17 18 17 30v1060c0 12-7 24-17 30l-918 530c-5 3-11 5-17 5s-12-2-17-5l-918-530c-11-6-17-18-17-30V719c0-12 7-24 17-30l918-530c5-3 11-5 17-5v1zm0-155c-33 0-65 8-95 25L237 555c-59 34-95 96-95 164v1060c0 68 36 130 95 164l918 530c29 17 62 25 95 25s65-8 95-25l918-530c59-34 95-96 95-164V719c0-68-36-130-95-164L1344 25c-29-17-62-25-95-25h1z",
    style: {
      fill: "#9dcced"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "arbitrum-ogo_svg__st1",
    d: "m642 2179 85-232 170 141-159 146z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "arbitrum-ogo_svg__st4",
    d: "M1172 644H939c-17 0-33 11-39 27L401 2039l241 139 550-1507c5-14-5-28-19-28l-1 1zM1580 644h-233c-17 0-33 11-39 27L738 2233l241 139 620-1701c5-14-5-28-19-28v1z"
  })))));
};
export default SvgArbitrumOgo;